export default __webpack_public_path__ + "static/style-tip-balance-151c93f5b47d9f5ea5f6bc9054bebbc1.png";